import styled, { css } from 'styled-components/macro';
import { SVGIconStyled } from '@yme/atoms/svg-icon';
import { colorBlackTransparent50, colorCoreGray1000Base } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
export const PlaceholderStyled = styled.div `
  position: relative;
  width: 100%;
  height: 100%;

  ${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}
`;
export const PlaceholderContentStyled = styled.div `
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transform: translate(-50%, -50%);
`;
export const IconWrapperStyled = styled.div `
  ${({ hasBackground }) => hasBackground &&
    css `
      box-sizing: border-box;
      border: 12px solid ${colorBlackTransparent50};
      border-radius: 50%;

      ${SVGIconStyled} {
        padding: ${INDENT.xxxs};
        border-radius: 50%;
        background-color: ${colorCoreGray1000Base};
      }
    `}
`;
